import { AssetSvgProps } from "../../../shared/assets"

export const defaultColors = {
    "col1n": "#4EB8FE",
    "col2n": "#000000"
}
function FacEye041({ colors = defaultColors, className, onClick, outerTransform, transform, startDrag }: AssetSvgProps) {
    return (
        <g transform={outerTransform}><g className={className} onClick={onClick} transform={transform} onMouseDown={startDrag} onTouchStart={startDrag}><defs>
                <path
                    fill={colors.col1n}
                    d="M9.15 8.95q1.55-1.55 1.55-3.7 0-2.15-1.55-3.7Q7.55-.05 5.4 0 3.15-.05 1.55 1.55 0 3.1 0 5.25q0 2.15 1.55 3.7 1.6 1.55 3.85 1.6 2.15-.05 3.75-1.6z"
                    id="FacEye041__Symbol_88_0_Layer0_0_FILL"
                />
                <path
                    fill={colors.col2n}
                    d="M6.3 1.55Q6.1 1.2 5.8.9 4.85-.05 3.45 0 2-.05 1 .9q-1 1-1 2.35 0 1.05.55 1.9L1 5.6q0 .05.05.05 1 .95 2.4 1Q4.85 6.6 5.8 5.6q1-.95 1-2.35 0-.95-.5-1.7z"
                    id="FacEye041__Symbol_89_0_Layer0_0_FILL"
                />
            </defs>
            <use
                xlinkHref="#FacEye041__Symbol_88_0_Layer0_0_FILL"
                transform="translate(171.2 161.5)"
                id="FacEye041__col1n"
            />
            <use
                xlinkHref="#FacEye041__Symbol_89_0_Layer0_0_FILL"
                transform="translate(173.05 163.4)"
                id="FacEye041__col2n"
            />
        </g></g>
    )
}
export default FacEye041
